export class Entity {
    Id: number;
    InsertDate: Date;
    InsertUser: string;
    UpdateDate?: Date;
    UpdateUser?: string;

}